import Box from "@mui/material/Box"
import { ym } from "@/utils/metrika"

export const TG_URL = "https://t.me/tribeEvent"

const TG_PATH =
  "M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"

/** Иконка Telegram в фирменном цвете — всегда заметна, не бледная */
export const TelegramIconLink = () => (
  <Box
    component="a"
    href={TG_URL}
    target="_blank"
    rel="noopener noreferrer"
    title="Telegram Tribe — события каждый день"
    onClick={() => ym.tgChannelClick()}
    sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}
  >
    <svg width="28" height="28" viewBox="0 0 24 24" fill="#229ED9">
      <path d={TG_PATH} />
    </svg>
  </Box>
)

/** Яркая кнопка «Вступай в Племя» — ведёт в Telegram */
const JoinTribeButton = () => (
  <Box
    component="a"
    href={TG_URL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => ym.tgChannelClick()}
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      flexShrink: 0,
      padding: "7px 11px",
      borderRadius: "100px",
      background: "linear-gradient(135deg, #7c6af5 0%, #a855f7 100%)",
      color: "#fff !important",
      fontSize: "12px",
      fontWeight: 700,
      lineHeight: "16px",
      whiteSpace: "nowrap",
      textDecoration: "none",
      boxShadow: "0 2px 10px rgba(124, 106, 245, 0.45)",
      transition: "transform 0.15s ease, box-shadow 0.15s ease",
      "&:hover": {
        transform: "translateY(-1px)",
        boxShadow: "0 4px 14px rgba(124, 106, 245, 0.6)",
      },
      "@media (min-width: 760px)": {
        fontSize: "14px",
        padding: "9px 18px",
      },
    }}
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
      <path d={TG_PATH} />
    </svg>
    Вступай в Племя
  </Box>
)

export default JoinTribeButton
